var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 5.16683H3.33333V13.8335C3.33333 14.1871 3.47381 14.5263 3.72386 14.7763C3.97391 15.0264 4.31304 15.1668 4.66667 15.1668H11.3333C11.687 15.1668 12.0261 15.0264 12.2761 14.7763C12.5262 14.5263 12.6667 14.1871 12.6667 13.8335V5.16683H4ZM11.0787 3.16683L10 1.8335H6L4.92133 3.16683H2V4.50016H14V3.16683H11.0787Z",
    fill: "#1F242E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.66c3a0df20a9b182e5037119d4501aa6.svg";
export { ForwardRef as ReactComponent };